import { PreferredLanguage } from "../graphql/graphql";
import { titleCase } from "../utils/String.utils";
// Custom formatting function that preserves all-caps words and handles special cases
export const formatLanguageLabel = (language) => {
    // Handle the special ASL case with double underscores
    if (language === "AMERICAN_SIGN_LANGUAGE__ASL_") {
        return "American Sign Language (ASL)";
    }
    return titleCase(language.replace(/_/g, " "));
};
export const PREFERRED_LANGUAGES = Object.values(PreferredLanguage).map((language) => ({
    value: language,
    label: formatLanguageLabel(String(language))
}));
